// src/modules/strava/pages/StravaCallbackPage/index.js
import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Spinner, Alert } from 'react-bootstrap';
import { useService } from '../../../../shared/hooks/useService';
import { useAuth } from '../../../../shared/hooks/useAuth';

const StravaCallbackPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const service = useService();
    const { user, isAuthenticated, isLoading } = useAuth();
    const [error, setError] = useState(null);
    const hasRun = useRef(false);

    useEffect(() => {
        if (isLoading) return;
        if (hasRun.current) return;

        if (!isAuthenticated) {
            navigate('/login');
            return;
        }

        hasRun.current = true;

        const handleCallback = async () => {
            const code = searchParams.get('code');
            const state = searchParams.get('state');
            const callbackError = searchParams.get('error');
            const username = user?.Username;

            if (callbackError) {
                setError('Strava authorization was denied.');
                setTimeout(() => navigate(`/profile/${username}`), 3000);
                return;
            }

            if (!code) {
                setError('Missing authorization code from Strava.');
                setTimeout(() => navigate(`/profile/${username}`), 3000);
                return;
            }

            try {
                await service.handleStravaCallback(code, state);
                navigate(`/profile/${username}`, {
                    state: { stravaConnected: true }
                });
            } catch (err) {
                setError(err.message || 'Failed to connect Strava');
                setTimeout(() => navigate(`/profile/${username}`), 3000);
            }
        };

        handleCallback();
    }, [isLoading, isAuthenticated]);

    return (
        <Container className="mt-5 text-center">
            {error ? (
                <Alert variant="danger">
                    <i className="bi bi-exclamation-triangle me-2"></i>
                    {error}
                    <p className="mt-2 mb-0 small">Redirecting to your profile...</p>
                </Alert>
            ) : (
                <div>
                    <Spinner animation="border" variant="primary" className="mb-3" />
                    <p>Connecting your Strava account...</p>
                </div>
            )}
        </Container>
    );
};

export default StravaCallbackPage;
